<template>
  <div>
    <CommonForm class="formDiv" @search="formSearch" :form-json="formjson" />
    <el-row :gutter="24">
      <el-col
        :xl="4"
        :lg="6"
        :md="8"
        :sm="12"
        :xs="12"
        v-for="(item, index) in list"
        :key="item.id"
      >
        <div class="addDiv" v-if="item.id === 'add'" @click.stop="handleAdd">{{ item.name }}</div>
        <div class="myDiv" v-else @mouseenter="handleEnter(index)" @mouseleave="handleLeave(index)">
          {{ item.name }}
          <el-button
            class="delBtn"
            type="text"
            @click.stop="handleDelete(item)"
            size="medium"
            v-if="item.show"
            >删除</el-button
          >
        </div>
      </el-col>
    </el-row>
    <Dialog
      :row="row"
      :type="type"
      :title="title"
      v-if="visible"
      @refresh="formSearch"
      :visible.sync="visible"
    />
  </div>
</template>

<script>
import formjson from './Model/Formjson.Item'
import Dialog from './dialog'
export default {
  props: {
    type: String,
    title: String
  },
  data() {
    return {
      list: [],
      row: {},
      visible: false,
      queryApi: this.$api.basicdata.basic_wine_list,
      deleteApi: this.$api.basicdata.basic_wine_delete
    }
  },
  components: {
    Dialog
  },
  computed: {
    formjson() {
      return formjson(this.type) || []
    }
  },
  methods: {
    formSearch(data) {
      let params = { ...data }
      params.type = this.type
      params.pageNum = 1
      params.pageSize = 9999

      this.$ajax.get(this.queryApi, params).then((res) => {
        this.list = res.data.list
        this.list.map((item) => {
          item.show = true
        })
        this.list.unshift({
          id: 'add',
          name: '新增'
        })
      })
    },
    handleEnter(index) {
      this.list[index].show = true
    },
    handleLeave(index) {
      this.list[index].show = false
    },
    handleAdd() {
      this.row = {}
      this.visible = true
    },
    handleDelete(row) {
      this.$confirm(`确认删除该` + this.title + `吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          let params = {
            id: row.id
          }
          this.$ajax
            .post(this.deleteApi, params)
            .then(() => {
              this.$message.success(this.title + '删除成功')
              this.formSearch()
            })
            .catch(() => {})
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="less">
.formDiv {
  margin: 16px 0 -8px;
}
.myDiv {
  position: relative;
  margin-top: 24px;
  height: 90px;
  line-height: 90px;
  font-size: 20px;
  color: #333333;
  text-align: center;
  background-image: url('../../../assets/wine_bg.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  box-shadow: 0 -2px 16px 0 rgba(18, 20, 22, 0.05);
  border-radius: 4px;
  .delBtn {
    position: absolute;
    right: 16px;
    bottom: 0;
  }
}
.addDiv {
  margin-top: 24px;
  height: 90px;
  line-height: 90px;
  font-size: 20px;
  color: #2a85ff;
  text-align: center;
  background: rgba(255, 255, 255, 0.39);
  border: 1px dashed #d1d1d1;
  border-radius: 4px;
  cursor: pointer;
}
</style>
